/** Created by azhou on 2018/7/10.*/
<template>
  <div>
    <public-title>{{Title}}
      <div class="ml-auto h6" slot="right">
        <span class="text-link" @click="$router.push({name:'OperationManage',query:{type:$route.query.type}})">返回列表</span>
        <span class="text-link ml-2" @click="addDisplay">添加展示项</span>
      </div>
    </public-title>
    <div class="bg-white load-area">
      <p v-if="AdminDataLists.total<=0" class="mt-3">当前没有数据</p>
      <div v-else>
        <ul class="list-head mt-3">
          <li class="w-50" v-for="item in titleArr" :key="item">
            {{item}}
            <i class="el-icon-edit text-link ml-2" v-show="item === '排序'" @click="changeSort"></i>
          </li>
        </ul>
        <ul class="list-item" v-for="item in AdminDataLists.lists" :key="item.id">
          <li class="w-50 list-item-col">{{item.title}}</li>
          <li class="w-50 list-item-col">
            <span class="text-link" @click="showBigImg(item)">查看大图</span>
          </li>
          <li class="w-50 list-item-col">
            <span v-if="!showSortInput">{{item.sort}}</span>
            <el-input class="w-50" v-else v-model="item.sort"></el-input>
          </li>
          <li class="w-50 list-item-col" :class="[item.status ? 'text-success' : 'text-danger']">{{item.status?'启用':'禁用'}}</li>
          <li class="w-50 list-item-col-end flex-wrap">
            <span class="text-link mr-2" @click="disabledAds(item)">{{item.status?'禁用':'启用'}}</span>
            <span class="text-link mr-2" @click="addDisplay(item)">编辑</span>
            <span class="text-link" @click="deleteAd(item)">删除</span>
          </li>
        </ul>
        <el-pagination background layout="prev, pager, next" class="mt-4"
                       :total="AdminDataLists.total" :current-page="Number(queryCon.page)"
                       @current-change="v => this.currentPage=v"/>
      </div>
    </div>
    <el-dialog title="广告项" :visible.sync="showAdDetail" center @close="showAdDetail = false;showSearch=false;currentItem={}" width="40%">
      <div class="d-center-start mb-3 ml-5" v-show="paramsId != 1">
        <left-text leftText="类型"/>
        <el-radio-group v-model="radio" class="d-center-between w-70">
          <el-radio-button label="3">酒店</el-radio-button>
          <el-radio-button label="5">民宿</el-radio-button>
          <el-radio-button label="6">景区</el-radio-button>
          <el-radio-button label="7">度假产品</el-radio-button>
          <el-radio-button label="8">品牌馆</el-radio-button>
        </el-radio-group>
      </div>
      <div class="d-center-start mb-3 ml-5">
        <left-text leftText="标题"/>
        <div class="w-40">
          <el-input v-model="currentItem.title" size="small" @keyup.enter.native="Search" >
            <el-button slot="append" icon="el-icon-search" @click="Search" >搜索</el-button>
          </el-input>
          <transition name="fade" v-if="showSearch">
            <div class="border" v-if="num > 0">
              <div v-for="(item,ind) in searchList" :key="ind" @click="complete(item)">{{item.title}}</div>
            </div>
            <div class="border" v-else>暂无数据</div>
          </transition>
        </div>
      </div>
      <div class="d-center-start mb-3 ml-5">
        <left-text leftText="排序"/>
        <el-input v-model="currentItem.sort" size="small" @keyup.enter.native="Search" class="w-20"></el-input>
      </div>
      <div class="d-center-start mb-3 ml-5">
        <left-text leftText="广告ID"/>
        <el-input v-model="currentItem.custom" size="small" @keyup.enter.native="Search" class="w-20"></el-input>
      </div>
      <div class="d-center-start mb-3 ml-5">
        <left-text leftText="广告链接"/>
        <el-input v-model="currentItem.link" size="small" @keyup.enter.native="Search" class="w-80"></el-input>
      </div>
      <div class="d-center-start mb-3 ml-5">
        <left-text leftText="广告词"/>
        <el-input v-model="currentItem.message" size="small" @keyup.enter.native="Search" class="w-80"></el-input>
      </div>
      <!-- <left-text-border class="mb-3 w-90 ml-5" leftText="广告词" v-model="currentItem.message"/> -->
      <div class="d-start-start ml-5">
        <left-text leftText="图片"/>
        <upload-image @fileChange="(imgs)=>{this.currentItem.pic = imgs[0];}"
                      :existImgs="currentItem.pic" :maxLength="1" editMode/>
      </div>
      <div slot="footer">
        <el-button slot="footer" @click="showAdDetail = false;currentItem={}">取消</el-button>
        <el-button slot="footer" type="primary" @click="ensureCtrol">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { UploadImages } from '@/assets/utils/uploadFiles'
  import {mapState,mapActions} from 'vuex'

  export default {
    data() {
      return {
        titleArr:['标题','图片','排序','状态','操作'],
        StyleLabel:[{id:0},{},{},{},{}],
        showSortInput:false,
        showAdDetail:false,
        a:{input: ''},
        currentItem:{
          title: '',
          sort: '',
          link:'',
          custom:'',
          message:'',
          pic:'',
          status:1,
        },
        currentPage:1,
        radio: '3',
        searchList: [],
        showSearch: false,
        num: 0,
      }
    },
    computed: {
      ...mapState(['AdminDataLists']),
      Title() { return this.$route.query.title; },
      paramsId() { return this.$route.query.id; },
      paramsType() { return this.$route.query.type; },
      queryCon() { return this.$route.query },
    },
    watch:{
      queryCon() { this.getDataLists(); },
      currentPage() { this.$router.push({name:this.$route.name,query:{...this.queryCon,page:this.currentPage}}) },
    },
    created() {
      this.getDataLists();
    },
    methods: {
      ...mapActions(['getAdminDataLists','sortProduct']),
      async Search () {
        let resData = await this.$axios.post('/pc/Admin/StoreList', { storeType: this.radio, title: this.tranTitle})
        if (resData.code == '00000' || resData.code == '99999') {
          this.searchList = resData.data.list || []
          this.num = resData.data.count
          this.showSearch = true
        }
      },
      addDisplay(item) {
        this.showAdDetail=true;
        if (item) {
          this.currentItem={
            ...this.currentItem,
            ...item
          };
        }
      },
      complete (item) {
        this.showSearch=false;
        this.currentItem.custom=item.id;
        this.currentItem.title=item.title;
      },
      changeSort () {
        if (this.showSortInput) {
          this.sortProduct({
            main_id:this.queryCon.mainId,
            sort:this.AdminDataLists.lists.map(v => {
              return {
                id:v.id,
                sort:v.sort
              }
            })
          })
        }
        this.showSortInput = !this.showSortInput;
      },
      //获取数据列表
      getDataLists() {
        this.getAdminDataLists({
          type:'advertise',
          data:{
            ads: this.paramsId,
            terminal_type:this.paramsType,
            page:this.currentPage
          }
        });
      },
      //查看大图
      showBigImg(item) {
        this._CarouselView({
          currentImg: 0,
          picArray: [item.pic]
        })
      },
      /*禁用/启用广告*/
      async disabledAds(item) {
        let res = await this.$axios.post('/pc/Admin/EditPromote',{
          id:item.id,
          status:item.status ? '0' : '1'
        });
        if (res.code === '00000') { this.getDataLists(); }
      },
      /*删除广告*/
      async deleteAd(item) {
        this._confirm('确认删除该项么？',async () => {
          let res = await this.$axios.post('/pc/Admin/DelPromote',{id:item.id,});
          if (res.code === '00000') { this.getDataLists(); }
        })
      },
      validateItem() {
        // if (!this.currentItem.title) return {code:false,msg:'请添加广告标题'}
        if (!this.currentItem.title) return {code:false,msg:'请添加广告标题'};
        if (!this.currentItem.custom) return {code:false,msg:'请搜索门店,或添写一个ID'};
        if (!this.currentItem.pic) return {code:false,msg:'请添加广告图片'};
        return {code:true,msg:'验证通过'}
      },
      /*添加、删除广告*/
      async ensureCtrol() {
        let result = this.validateItem();
        if (result.code) {
          let url = this.currentItem.id ? '/pc/Admin/EditPromote' : '/pc/Admin/AddPromote';
          this.currentItem.pic = (await UploadImages(this.currentItem.pic))[0];
          // this.currentItem.title = this.tranTitle;
          // this.currentItem.custom = this.tranId;
          let res = await this.$axios.post(url,{
            ads: this.paramsId,
            terminal_type:this.paramsType,
            store_type: this.paramsId == 1 ? 'ads' : this.radio,
            ...this.currentItem
          });
          if (res.code === '00000') this._alert('操作成功',() => {
            this.showAdDetail = false;
            this.currentItem = {};
            this.getDataLists();
          })
        } else this._alert(result.msg,null,'error')
      }
    }
  }
</script>

<style lang="scss" scoped>
.border{
    margin-top: 10px;
    position: absolute;
    background-color: #fff;
    padding: 10px;
    width: 57%;
    z-index: 9;
    border-radius: 5px;
    min-height: 200px;
    div{
      height: 30px;
      line-height: 30px;
      border-bottom: 1px solid #eee;
      cursor: pointer;
    }
}
</style>